import axios from "../../AxiosConfig";
import type {
  MemberBindingResponse,
  MembersListResponse,
  OrganizationInviteCreate,
  PendingInvitesListResponse,
  PermissionGroupsResponse,
  ReplaceBindingsRequest,
  RoleCreateRequest,
  RolePatchRequest,
  RoleResponse,
  RolesListResponse,
  UserPermissionsResponse,
} from "./authorizationModels";

const API_URL = import.meta.env.VITE_APP_API_URL;
const AUTHORIZATION_URL = `${API_URL}/authorization`;
/** Members list/bindings (roles governance). */
const ORGANIZATIONS_URL = `${API_URL}/organizations`;
/** Legacy singular org routes — invite lives here, not under /organizations. */
const ORGANIZATION_URL = `${API_URL}/organization`;

export function getUserPermissions() {
  return axios.get<UserPermissionsResponse>(`${AUTHORIZATION_URL}/permissions`);
}

export function getPermissionGroups() {
  return axios.get<PermissionGroupsResponse>(
    `${AUTHORIZATION_URL}/permission-groups`
  );
}

export function listRoles() {
  return axios.get<RolesListResponse>(`${AUTHORIZATION_URL}/roles`);
}

export function createRole(body: RoleCreateRequest) {
  return axios.post<RoleResponse>(`${AUTHORIZATION_URL}/roles`, body);
}

export function patchRole(roleId: string, body: RolePatchRequest) {
  return axios.patch<RoleResponse>(
    `${AUTHORIZATION_URL}/roles/${roleId}`,
    body
  );
}

export function deleteRole(roleId: string) {
  return axios.delete(`${AUTHORIZATION_URL}/roles/${roleId}`);
}

export function listMembers() {
  return axios.get<MembersListResponse>(`${ORGANIZATIONS_URL}/members`);
}

export function replaceMemberBindings(
  userId: string,
  body: ReplaceBindingsRequest
) {
  // OpenAPI: 200 = MemberBindingResponse[] (not full MemberResponse).
  return axios.put<MemberBindingResponse[]>(
    `${ORGANIZATIONS_URL}/members/${userId}/bindings`,
    body
  );
}

export function deleteMember(userId: string) {
  return axios.delete(`${ORGANIZATIONS_URL}/members/${userId}`);
}

export function inviteMember(body: OrganizationInviteCreate) {
  return axios.post(`${ORGANIZATION_URL}/invite`, body);
}

export function listPendingInvites() {
  return axios.get<PendingInvitesListResponse>(`${ORGANIZATIONS_URL}/invites`);
}
